import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './scss/application.scss';  

const reactAppRoot = document.getElementById('react-root');

if (reactAppRoot) {
    ReactDOM.createRoot(reactAppRoot).render(
        <App />
        //<React.StrictMode>
        //    <App /> 
        //</React.StrictMode>, 
    )
}

Array.prototype.last = function () {   
    return this[this.length - 1];
};


